import { render, staticRenderFns } from "./label-modal.vue?vue&type=template&id=d786801a&"
import script from "./label-modal.vue?vue&type=script&lang=js&"
export * from "./label-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports